import { format } from '@/helpers';

/**
 * Module namespaced.
 */
export const namespaced = true;

/**
 * Module state.
 */
export const state = {
  active: 'BTC',
  coins: [
    {
      initial: 'BTC',
      total: 3525000,
      title: 'Bitcoin',
      percent: 2.45,
      color: '#f5a623',
      formated: format(3525000 / 100),
    },
    {
      initial: 'ETH',
      total: 109000,
      title: 'Ethereum',
      percent: 4.35,
      color: '#627eea',
      formated: format(109000 / 100),
    },
    {
      initial: 'QTUM',
      total: 1340,
      title: 'QTUM',
      percent: -1.22,
      color: '#35a4d6',
      formated: format(1340 / 100),
    },
    {
      initial: 'EOS',
      total: 3221,
      title: 'EOS',
      percent: -3.39,
      color: '#8364ff',
      formated: format(3221 / 100),
    },
    {
      initial: 'LTC',
      total: 46400,
      title: 'Litecoin',
      percent: 47.13,
      color: '#999999',
      formated: format(46400 / 100),
    },
    {
      initial: 'DASH',
      total: 67501,
      title: 'DASH',
      percent: -13.01,
      color: '#007ece',
      formated: format(67501 / 100),
    },
  ],
};

/**
 * Module getters.
 */
export const getters = {
  coin: ({ coins, active }) => coins.find(({ initial }) => initial === active),
};

/**
 * Module mutations.
 */
export const mutations = {
  SET_ACTIVE (state, initial) {
    state.active = initial;
  },
};
